// Mirrors Tp_Communication.Constant.PlatformCostSummaryConstants.CostTypes — keep in sync.
const PlatformCostSummaryCostTypesEnum = {
  Assignment: 'Assignment',
  Additional: 'Additional',
  Development: 'Development',
};

export default PlatformCostSummaryCostTypesEnum;
